<template>
  <q-card-section>
    <q-tabs
      v-model="tab"
      dense
      class="text-grey"
      active-color="primary"
      indicator-color="primary"
      align="justify"
      narrow-indicator
    >
      <q-tab name="basic" label="Dados básicos"></q-tab>
      <q-tab name="payment_form" label="Dados de pagamento"></q-tab>
      <q-tab name="address" label="Endereço"></q-tab>
      <q-tab name="donations" label="Histórico de doações"></q-tab>
      <q-tab name="relashionship" label="Histórico de relacionamento"></q-tab>
      <q-tab name="donatorJournal" label="Jornada do doador"></q-tab>
    </q-tabs>

    <q-separator></q-separator>

    <q-tab-panels v-model="tab" animated>
      <q-tab-panel name="basic">
        <div class="q-pa-md">
          <div class="row q-col-gutter-xs">
            <q-form class="col-12" ref="formBasic">
              <div class="row q-col-gutter-xs">
                <div class="col-4">
                  <q-select
                    outlined
                    v-model="donator.payment_form"
                    :rules="[required]"
                    options-dense
                    map-options
                    @blur="formPayment"
                    label="Forma de Pagamento"
                    :options="formaPagamentoOptions"
                    option-value="id"
                    option-label="name"
                  />
                </div>
                <div class="col-4">
                  <q-input outlined v-model="donator.name" :label="labelFirst" @blur="basic"
                           :rules="[required]"/>
                </div>

                <div class="col-4">
                  <q-input outlined v-model="donator.last_name" :label="labelLast" @blur="basic"
                           :rules="[required]"/>
                </div>
                <div class="col-4">
                  <q-input outlined v-model="donator.email" label="E-mail" @blur="donatorByEmailBlur"
                           :rules="[validaEmail]"/>
                </div>
                <div class="col-4">
                  <q-input outlined v-model="donator.document" :label="labelDocument" :mask="maskDocument"
                           @blur="donatorByCPFBlur"
                           unmasked-value
                           :rules="[required, this.valida]"/>
                </div>
                <div class="col-4">
                  <q-input outlined v-model="donator.tel_res" :label="labelTel" mask="(##) ####-####"
                           @blur="basic"
                          />
                </div>
                <div class="col-4">
                  <q-input outlined v-model="donator.tel_cel" label="Telefone celular" mask="(##) # ####-####"
                           @blur="basic"
                           :rules="[required]"/>
                </div>
                <div class="col-4">
                  <q-radio @blur="basic" v-model="donator.sex" val="M" label="Masculino"/>
                  <q-radio @blur="basic" v-model="donator.sex" val="F" label="Feminino"/>
                </div>
                <div class="col-4">
                  <q-radio @blur="basic" v-model="person" val="1" label="Pessoa jurídica"/>
                  <q-radio @blur="basic" v-model="person" val="2" label="Pessoa física"/>
                </div>
                <div class="col-4">
                  <q-input outlined mask="##/##/####" :rules="[required]"
                           v-model="donator.birthday" label="Data de aniversário" @blur="basic">
                    <template v-slot:append>
                      <q-icon name="event" class="cursor-pointer">
                        <q-popup-proxy ref="qDateProxy">
                          <q-date v-model="donator.birthday" mask="DD/MM/YYYY" @input="() => $refs.qDateProxy.hide()"/>
                        </q-popup-proxy>
                      </q-icon>
                    </template>
                  </q-input>
                </div>
                <div class="col-4">
                  <q-select
                    outlined
                    v-model="donator.donator_status"
                    label="Status do doador"
                    options-dense
                    map-options
                    :options="statusDoadorOptions"
                    option-value="id"
                    option-label="name" :rules="[required]"
                    @blur="basic"
                  />
                </div>

                <div class="col-4">
                  <q-select
                    outlined
                    v-model="donator.shipping_method"
                    options-dense
                    map-options
                    @blur="basic"
                    label="Forma de Envio"
                    :options="formaEnvioOptions"
                    option-value="id"
                    option-label="name"
                  />
                </div>
                  <div class="col-4">
                  <q-select
                    outlined
                    v-model="donator.donator_type"
                    :rules="[required]"
                    options-dense
                    map-options
                    label="Tipo do doador"
                    :options="tipoDoadorOptions"
                    option-value="id"
                    option-label="name"
                    @blur="basic"
                  />
                </div> <div class="col-4">
                <q-input outlined v-model="cadastro_doador" :disable="true"   label="Data de Cadastro"/>
                </div>
              </div>
            </q-form>
          </div>
        </div>

      </q-tab-panel>

      <q-tab-panel name="payment_form">
        <div class="text-h6"></div>

        <div class="q-pa-md">

          <div class="row q-col-gutter-xs">
            <q-form class="col-12" ref="formPayment">
              <div class="row q-col-gutter-xs">

                <div class="col-4">
                  <q-input outlined v-model="donator.recurrence_value" unmasked-value
                           mask="R$ #########,##" @blur="formPayment"
                           label="Valor" :rules="[required]"/>
                </div>
                <div v-if="donator.payment_form.id == 11" class="col-4">
                  <q-input outlined v-model="donator.maturity_day" unmasked-value @blur="formPayment"
                           label="Dia de recorrência"/>
                </div>
                <div v-if="donator.payment_form.id == 11" class="col-4">
                  <q-input outlined v-model="donator.bank" @blur="formPayment"
                           label="Banco"/>
                </div>
                <div v-if="donator.payment_form.id == 11" class="col-4">
                  <q-input outlined v-model="donator.agency" @blur="formPayment"
                           label="Agência bancária"/>
                </div>
                <div v-if="donator.payment_form.id == 11" class="col-4">
                  <q-input outlined v-model="donator.bank_account" @blur="formPayment"
                           label="Conta bancária"/>
                </div>
                <div v-if="donator.payment_form.id == 9" class="col-4">
                  <q-input outlined v-model="donator.card_number" @blur="formPayment"
                           label="Número do cartão"/>
                </div>
                <div v-if="donator.payment_form.id == 9" class="col-4">
                  <q-input outlined v-model="donator.card_maturity" mask="##/####" @blur="formPayment"
                           label="Vencimento do cartão"/>
                </div>
                <div v-if="donator.payment_form.id == 9" class="col-4">
                  <q-input outlined v-model="donator.card_cvv" @blur="formPayment"
                           label="Código de segurança do cartão"/>
                </div>
              </div>
            </q-form>
          </div>
        </div>
      </q-tab-panel>
      <q-tab-panel name="address">
        <div class="q-pa-md">
          <div class="row q-col-gutter-xs">
            <q-form class="col-12" ref="formAddress">
              <div class="row q-col-gutter-xs">
                <div class="col-4">
                  <q-input outlined v-model="donator.zipcode" label="CEP" @blur="onZipCode" mask="#####-###"
                           :rules="[required]"/>
                </div>
                <div class="col-4">

                  <q-input outlined v-model="donator.street" label="Logradouro" @blur="formAddress"
                           :rules="[required]"/>
                </div>
                <div class="col-4">
                  <q-input outlined v-model="donator.number" label="Número" @blur="formAddress"
                           :rules="[required]"/>
                </div>
                <div class="col-4">
                  <q-input outlined v-model="donator.complement" label="Complemento"/>
                </div>
                <div class="col-4">
                  <q-input outlined v-model="donator.neighborhood" label="Bairro" @blur="formAddress"
                           :rules="[required]"/>
                </div>

                <div class="col-4">
                  <q-input outlined v-model="donator.city" label="Cidade" @blur="formAddress"
                           :rules="[required]"/>
                </div>
                <div class="col-4">
                  <q-input outlined v-model="donator.state" label="Estado" @blur="formAddress"
                           :rules="[required]"/>
                </div>
              </div>
            </q-form>
          </div>
        </div>
      </q-tab-panel>
      <q-tab-panel name="donations">
        <q-table
          title="Doações"
          :data="donator.donation"
          :columns="columns"
          row-key="name"
          :pagination.sync="pagination"

        >
          <template v-slot:top="props">
            <div class="col-4 q-table__title">Doações</div>
            <div class="col-7 q-table__title">&nbsp;</div>
            <div class="col-1 q-table__title">
              <q-btn color="bg-purple-10" outline icon="add" @click="openNewDonation"></q-btn>
            </div>
          </template>

           <template v-slot:body-cell-options="value">
             <q-td>

              <q-btn v-if="value.row.url_ticket_payment" target="_blank" type="a" :href="value.row.url_ticket_payment" round color="primary" icon="backup">
               </q-btn>

             </q-td>
           </template>
          <template v-slot:body-cell-extra="value">
            <q-td>
              <q-chip square color="teal" text-color="white" v-if="value.value == 1" label="SIM"/>
              <q-chip square color="red" text-color="white" v-if="value.value == 0" label="NÃO"/>
            </q-td>
          </template>
          <template v-slot:body-cell-payment_form="value">
            <q-td>
              <q-chip square color="blue-grey-5" text-color="white" v-if="value.value == 'BOLETO'"
                      label="BOLETO"/>
              <q-chip square color="brown-3" text-color="black" v-if="value.value == 'CONTA OI'"
                      label="CONTA OI"/>
              <q-chip square color="teal" text-color="white" v-if="value.value == 'CORPORATIVA'"
                      label="CORPORATIVA"/>
              <q-chip square color="yellow-5" text-color="black"
                      v-if="value.value == 'DEPÓSITO BANCÁRIO'" label="DEPÓSITO BANCÁRIO"/>
              <q-chip square color="blue-8" text-color="white"
                      v-if="value.value == 'CARTÃO DE CRÉDITO'" label="CARTÃO DE CRÉDITO"/>
              <q-chip square color="green-8" text-color="white"
                      v-if="value.value == 'TRANSFERÊNCIA BANCÁRIA'"
                      label="TRANSFERÊNCIA BANCÁRIA"/>
              <q-chip square color="pink-5 " text-color="black"
                      v-if="value.value == 'DEBITO AUTOMATICO'" label="DEBITO AUTOMATICO"/>
              <q-chip square color="purple-11 " text-color="black"
                      v-if="value.value == 'PAYPAL'" label="PAYPAL"/>
              <q-chip square color="cyan-2 " text-color="black"
                      v-if="value.value == 'TRANSFERENCIA IDENTIFICADA'" label="TRANSFERENCIA IDENTIFICADA"/>
              <q-chip square color="indigo-5 " text-color="black"
                      v-if="value.value == 'TRANSFERENCIA SEM RELACIONAMENTO'" label="TRANSFERENCIA SEM RELACIONAMENTO"/>
              <q-chip square color="teal-3 " text-color="black"
                      v-if="value.value == 'POLEN'" label="POLEN"/>
              <q-chip square color="orange-2 " text-color="black"
                      v-if="value.value == 'PRESENTE SOLIDARIO'" label="PRESENTE SOLIDARIO"/>
            </q-td>
          </template>
          <template v-slot:body-cell-channel="value">
            <q-td>
              <channel :channel="value.row.channel"></channel>
            </q-td>
          </template>
          <template v-slot:body-cell-donation_status="value">
            <q-td>
              <q-chip square color="yellow" text-color="black" v-if="value.value == 'ABERTO'"
                      label="ABERTO"/>
              <q-chip square color="teal" text-color="white"
                      v-if="value.value == 'QUITADO'" label="QUITADO"/>
              <q-chip square color="orange" text-color="black"
                      v-if="value.value == 'CANCELADO PELO BANCO'" label="CANCELADO PELO BANCO"/>
              <q-chip square color="red" text-color="white" v-if="value.value == 'CANCELADO PELO DOADOR'"
                      label="CANCELADO PELO DOADOR"/>
            </q-td>
          </template>

        </q-table>
      </q-tab-panel>
      <q-tab-panel name="relashionship">
        <div class="q-pb-md">
          <q-timeline color="primary">
            <q-timeline-entry heading>
              Histórico de relacionamento
            </q-timeline-entry>
            <q-timeline-entry v-for="history in donator.donator_history" :key="history.id"
                              :icon="chooseIcon(history.type)"
            >
              <template v-slot:title>
                {{history.title}}
              </template>
              <template v-slot:subtitle>
                {{formatDate(history.created_at)}}
              </template>

              <div>
                Descrição: <br>
                <span v-html="history.description"></span><br>
                <div v-if="history.email_send_date">
                  Data de envio do email: {{formatDate(history.email_send_date)}}
                </div>
                <div v-if="history.user">
                  <b>Autor do registro:</b> {{history.user.name}}
                </div>
              </div>
            </q-timeline-entry>
          </q-timeline>
        </div>
      </q-tab-panel>
      <q-tab-panel name="donatorJournal">
        <div class="q-pb-md">
          <donator-journal :donator="donator"></donator-journal>
        </div>
      </q-tab-panel>
    </q-tab-panels>
    <q-inner-loading :showing="$apollo.loading">
      <q-spinner-dots size="50px" color="primary"/>
    </q-inner-loading>
    <q-dialog v-model="created">
      <q-card>
        <q-card-section>
          <div class="text-h6">Sucesso!</div>
        </q-card-section>

        <q-card-section>
          O doador foi salvo com sucesso!
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="OK" color="primary"   @click="retorna"/>
        </q-card-actions>
      </q-card>
    </q-dialog>
    <q-dialog v-model="document">
      <q-card>
        <q-card-section>
          <div class="text-h6">Erro!</div>
        </q-card-section>

        <q-card-section>
          Este documento já está na base de dados!
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="OK" color="primary" @click="document = false"/>
        </q-card-actions>
      </q-card>
    </q-dialog>
    <q-dialog v-model="email">
      <q-card>
        <q-card-section>
          <div class="text-h6">Erro!</div>
        </q-card-section>

        <q-card-section>
          Este e-mail já está na base de dados!
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="OK" color="primary" @click="email = false"/>
        </q-card-actions>
      </q-card>
    </q-dialog>
    <!-- Nova doacao -->
    <q-dialog v-model="newDonation">
      <q-card style="width: 80vw; max-width: 80vw;">
        <q-card-section>

          <div class="row">
            <div class="col-11">
              <div class="text-h6">Nova doação para {{donator_name}}</div>
            </div>
            <!--<div class="col-1">
              <q-btn color="primary" icon="create"
                     @click="$router.push({name:'donator.edit',params: {id: donator_id}})"></q-btn>
            </div>-->
            <!--<div class="col-1">
              <q-btn color="primary" icon="headset_mic"
                     @click="$router.push({name:'atendimento',params: {id: donator_id}})"></q-btn>
            </div>-->
          </div>
        </q-card-section>
        <new-donation :donator="donator" @newdonationok="update"></new-donation>
        <!-- <donations :alert="alert" :donator_id="donator_id" :donator_name="donator_name" @loading="loadingChange"/>-->
        <q-card-actions align="right" class="bg-white text-primary">
          <q-btn flat color="primary" label="Fechar" @click="newDonation = false"/>
        </q-card-actions>
       <!-- <q-inner-loading :showing="loadingDonations">
          <q-spinner-dots size="50px" color="primary"/>
        </q-inner-loading>-->
      </q-card>
    </q-dialog>
  </q-card-section>
</template>

<script>
import { DONATOR, DONATOR_BY_CPF, DONATOR_BY_EMAIL, UPDATE_DONATOR } from '../graphql/graphql'
import { DateTime } from 'luxon'
import numeraljs from 'numeraljs'
import DonatorJournal from '../components/DonatorJournal'
import NewDonation from '../components/NewDonation'
import Channel from '../components/Channel'
import { numberToReal } from '../helpers'

export default {
  name: 'Donations',
  components: { NewDonation, DonatorJournal, Channel },
  props: {
    donator_id: {
      type: String,
      required: true
    },
    donator_name: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      tab: 'basic',
      newDonation: false,
      person: 'F',
      labelFirs: 'Primeiro Nome',
      labelLast: 'Último Nome',
      labelDocument: 'CPF',
      labelTel: 'Telefone Residencial',
      donator: {
        donator_type: { id: 0 },
        payment_form: { id: 0 },
        shipping_method: {
          id: 0
        },
        donation: {},
        id: '',
        sex: '',
        neighborhood: '',
        complement: '',
        city: '',
        state: '',
        country: 'BR',
        document: '',
        email: '',
        last_name: '',
        street: '',
        number: '',
        birthday: '',
        zipcode: '',
        tel_res: '',
        tel_cel: '',
        bank: '',
        sms: '',
        informative: 1,
        card_matutiry: ''
      },
      loading: true,
      dense: false,
      formaPagamento: [],
      formaPagamentoOptions: [
        { id: 1, name: 'Boleto' },
        { id: 9, name: 'Cartão de crédito' },
        { id: 11, name: 'Débito automático' },
        { id: 12, name: 'PayPal' },
        { id: 13, name: 'Transferência Identificada' },
        { id: 14, name: 'Transferência sem relacionamento' },
        { id: 15, name: 'Pólen' },
        { id: 16, name: 'Presente solidário' }
      ],
      document: false,
      email: false,
      created: false,
      statusDoador: 0,
      statusDoadorOptions: [
        { id: 1, name: 'Ativo' },
        { id: 4, name: 'Atraso 1' },
        { id: 2, name: 'Atraso 2' },
        { id: 9, name: 'Inativo' },
        { id: 13, name: 'Cancelado' }
      ],
      maskDocument: '##.###.###/####-##',
      formaEnvio: [],
      formaEnvioOptions: [
        { id: 1, name: 'Correio' },
        { id: 2, name: 'E-mail' }
      ],
      tipoDoador: [],
      tipoDoadorOptions: [
        { id: 1, name: 'Regular' },
        { id: 2, name: 'Único' },
        { id: 3, name: 'Ocasional' }
      ],
      pagination: {},
      emailPattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      columns: [
        {
          name: 'our_number',

          label: 'Nosso número',
          align: 'left',
          field: 'our_number'

        }, {
          name: 'extra',

          label: 'Extra',
          align: 'left',
          field: 'extra',
          format: val => { if (val == 1) { return val } return 0 }

        }, {
          name: 'payment_form',

          label: 'Forma de pagamento',
          align: 'left',
          field: 'payment_form',
          format: val => { if (val) return val.name }
        }, {
          name: 'donation_status',

          label: 'Regra de doação',
          align: 'left',
          field: 'donation_status',
          format: val => val.name
        }, {
          name: 'maturity_date',

          label: 'Vencimento',
          align: 'left',
          field: 'maturity_date',
          format: val => {
            if (val) {
              return DateTime.fromSQL(val, { locale: 'pt-br' }).toLocaleString()
            }
          }
        }, {
          name: 'payment_date',

          label: 'Pagamento',
          align: 'left',
          field: 'payment_date',
          format: val => {
            if (val) {
              return DateTime.fromSQL(val, { locale: 'pt-br' }).toLocaleString()
            }
          }
        }, {
          name: 'amount',

          label: 'Valor',
          align: 'left',
          field: 'amount',
          format: val => numberToReal(val)
        }, {
          name: 'transaction_code',

          label: 'Código da transação',
          align: 'left',
          field: 'transaction_code'

        }, {
          name: 'tax',

          label: 'Taxas',
          align: 'left',
          field: 'tax',
          format: val => numeraljs(val).format('0,00')

        }, {
          name: 'paid_amount',

          label: 'Valor pago',
          align: 'left',
          field: 'paid_amount',
          format: val => 'R$ ' + numeraljs(val).format('0,00')
        }, {
          name: 'campangn',

          label: 'Campanha',
          align: 'left',
          field: 'campangn',
          format: val => val ? val.name : ''
        }, {
          name: 'channel',

          label: 'Canal',
          align: 'left',
          field: 'channel'
        }, {
          name: 'options',

          label: 'Opções',
          align: 'left',
          field: 'options'

        }
      ]
    }
  },
  methods: {
    update () {
      this.$apollo.queries.donator.skip = false
      this.$apollo.queries.donator.refetch().then(result => {
        this.donator = result.data.donator
      })
    },
    validaEmail (email) {
      if (this.donator.payment_form.id < 12) {
        return this.emailPattern.test(email) || 'Necessário um e-mail válido'
      }
    },
    required (value) {
      // alert(this.donator.payment_form.id)
      if (this.donator.payment_form.id < 12) {
        return !!value || 'Campo obrigatório'
      }
    },
    openNewDonation () {
      this.newDonation = true
    },
    save (ev) {
      this.donator.donator_type = ev.opt
      console.log('ev', ev)
    },
    valida (ev) {
      if (this.donator.payment_form.id < 12) {
        const mod11 = (num) => num % 11
        const NOT = (x) => !x
        const isEqual = (a) => (b) => b === a
        const mergeDigits = (num1, num2) => `${num1}${num2}`
        const getTwoLastDigits = (cpf) => `${cpf[9]}${cpf[10]}`
        const getCpfToCheckInArray = (cpf) => cpf.substr(0, 9).split('')
        const generateArray = (length) => Array.from({ length }, (v, k) => k)

        const isIn = (list) => (value) =>
          list.findIndex(v => value === v) >= 0

        const isSameDigitsCPF = (cpfFull) =>
          isIn(generateArray(10).map(generateStringSequence(11)))(cpfFull)

        const generateStringSequence = (times) => (char) =>
          (`${char}`.repeat(times))

        const toSumOfMultiplication = (total) => (result, num, i) =>
          result + (num * total--)

        const getSumOfMultiplication = (list, total) =>
          list.reduce(toSumOfMultiplication(total), 0)

        const getValidationDigit = (total) => (cpf) =>
          getDigit(mod11(getSumOfMultiplication(cpf, total)))

        const getDigit = (num) =>
          (num > 1)
            ? 11 - num
            : 0

        const isValidCPF = (cpfFull) => {
          const cpf = getCpfToCheckInArray(cpfFull)
          const firstDigit = getValidationDigit(10)(cpf)
          const secondDigit = getValidationDigit(11)(cpf.concat(firstDigit))
          // eslint-disable-next-line func-call-spacing
          return isEqual(getTwoLastDigits(cpfFull))
          // eslint-disable-next-line no-unexpected-multiline
          (mergeDigits(firstDigit, secondDigit))
        }
        const validate = (CPF) => NOT(isSameDigitsCPF(CPF)) && isValidCPF(CPF)
        return validate(ev) || 'CPF inválido'
      }
      return true
    },
    chooseIcon (type) {
      let result = ''
      switch (type) {
        case 'ENVIO DE EMAIL':
          result = 'mail'
          break
        case 'ENVIO PROSPECT':
          result = 'how_to_vote'
          break
        case 'EMAIL CARTAO NÃO PROCESSADO':
          result = 'layers_clear'
          break
        case 'SYSTEM':
          result = 'dvr'
          break
        case 'USER':
          result = 'account_circle'
          break
      }
      return result
    },
    formatDate (date) {
      return DateTime.fromSQL(date, {
        locale:
            'pt-br'
      }).toLocaleString()
    },
    retorna () {
      this.created = false
      this.$router.push({ name: 'doadores' })
    },
    close () {
      this.$emit('closeDonator')
    },
    stepTwo (data) {
      this.two = false
      this.tab = 'payment_form'
    },
    stepThree (data) {
      this.three = false
      this.tab = 'address'
    },
    donatorByEmailBlur () {
      if (this.donator.payment_form.id < 12) {
        if (this.donator.id === 0) {
          this.$apollo.addSmartQuery('donatorByEmail', {
            query: DONATOR_BY_EMAIL,
            variables () {
              return {
                'email': this.donator.email
              }
            },
            // pollInterval: 300,
            update (store, data) {
              if (store.donatorByEmail.length > 0) {
                this.email = true
                this.donator.email = ''
              } else {
                this.atualiza()
              }
            }
          })
        }
        this.basic()
      }
    },
    donatorByCPFBlur () {
      // alert(this.donator.payment_form.id)
      if (this.donator.payment_form.id < 12) {
        if (this.donator.id === 0) {
          this.$apollo.addSmartQuery('donatorByCPF', {
            query: DONATOR_BY_CPF,
            variables () {
              return {
                'cpf': this.donator.document
              }
            },
            // pollInterval: 300,
            update (store, data) {
              if (store.donatorByCPF.length > 0) {
                this.document = true
                this.donator.document = ''
              } else {
                this.atualiza()
              }
            }
          })
        }
        this.basic()
      }
    },
    atualiza () {
      this.$apollo.mutate({
        mutation: UPDATE_DONATOR,
        variables: {
          id: this.donator_id,
          name: this.donator.name,
          document: this.donator.document,
          email: this.donator.email,
          last_name: this.donator.last_name,
          street: this.donator.street,
          number: this.donator.number,
          complement: this.donator.complement,
          neighborhood: this.donator.neighborhood,
          person_type: this.donator.person_type,
          city: this.donator.city,
          birthday: this.donator.birthday,
          state: this.donator.state,
          zipcode: this.donator.zipcode,
          tel_res: this.donator.tel_res,
          tel_com: this.donator.tel_com,
          country: this.donator.country,
          tel_cel: this.donator.tel_cel,
          sex: this.donator.sex,
          informative: this.donator.informative,
          recurrence_value: this.donator.recurrence_value,
          maturity_day: this.donator.maturity_day,
          donator_status_id: this.donator.donator_status.id,
          shipping_method_id: this.donator.shipping_method ? this.donator.shipping_method.id : 0,
          donator_type_id: this.donator.donator_type.id,
          payment_form_id: this.donator.payment_form.id,
          bank: this.donator.bank,
          bank_account: this.donator.bank_account,
          agency: this.donator.agency,
          card_number: this.donator.card_number,
          card_matutiry: this.donator.card_matutiry,
          sms: this.donator.sms
        },
        update: (store, data) => {
          this.created = true
        }
      })
        .catch(error => {
          const errors = { error }
          console.error(error)
          console.error(errors)
        })
    },
    basic () {
      this.donator.country = 'BR'
      if (this.donator.payment_form.id < 12) {
        this.$refs.formBasic.validate().then(result => {
          if (result) {
            this.atualiza()
          } else {
            alert('Verifique os campos marcados em vermelho!')
          }
        })
      } else {
        this.atualiza()
      }
    },
    formAddress () {
      this.donator.country = 'BR'
      if (this.donator.payment_form.id < 12) {
        this.$refs.formAddress.validate().then(result => {
          if (result) {
            this.atualiza()
          } else {
            alert('Verifique os campos marcados em vermelho!')
          }
        })
      } else {
        this.atualiza()
      }
    },
    formPayment () {
      this.donator.country = 'BR'
      if (this.donator.payment_form.id < 12) {
        this.$refs.formPayment.validate().then(result => {
          if (result) {
            this.atualiza()
          } else {
            alert('Verifique os campos marcados em vermelho!')
          }
        })
      } else {
        this.atualiza()
      }
    },
    onZipCode () {
      const cep = this.donator.zipcode.replace('.', '').replace('-', '')
      fetch(`//viacep.com.br/ws/${cep}/json/`).then(res => res.json()).then(res => {
        this.donator.neighborhood = res.bairro
        this.donator.complement = res.complemento
        this.donator.city = res.localidade
        this.donator.state = res.uf
        this.donator.street = res.logradouro
        this.atualiza()
        // console.log(res)
      })
    }
  },
  apollo: {
    donator: {
      query: DONATOR,
      variables () {
        return {
          id: this.donator_id
        }
      },
      skip: true
    },
    UpdateDonatorSite: {
      query: UPDATE_DONATOR,
      variables () {
        return {
          donator: this.donator
        }
      },
      skip: true
      // pollInterval: 300, // ms
    }
  },
  computed: {
    maskBank () {
      return this.masks[this.donator.bank]
    },
    cadastro_doador () {
      return this.formatDate(this.donator.created_at)
    }
  },
  mounted () {
    this.$apollo.queries.donator.skip = false
    this.$apollo.queries.donator.refetch().then(result => {
      this.donator = result.data.donator
      this.person = this.donator.person_type
      this.maskDocument = this.person == 2 ? '###.###.###-##' : '##.###.###/####-##'
    })
  },
  watch: {
    person: function (newVal, oldVal) {
      if (newVal === '2') {
        this.donator.person_type = '2'
        this.labelFirst = 'Primeiro Nome'
        this.labelLast = 'Último Nome'
        this.labelDocument = 'CPF'
        this.labelTel = 'Telefone Residencial'
        this.maskDocument = '###.###.###-##'
      }
      if (newVal === '1') {
        this.donator.person_type = '1'
        this.labelFirst = 'Nome Fantasia'
        this.labelLast = 'Razão Social'
        this.labelDocument = 'CNPJ'
        this.labelTel = 'Telefone comercial'
        this.maskDocument = '##.###.###/####-##'
      }
    }
  }
}
</script>

<style>
  div.q-field__native span {
    color: #590a7f !important;
  }
</style>
